import {
  LOGIN_REQUESTING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  SET_AUTHENTICATED,
  UNSET_AUTHENTICATED,
} from './constants'

const initialState = {
  isAuthenticated: false,
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  email: '',
  logo: '',
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: true,
      }

    case UNSET_AUTHENTICATED:
      return {
        ...state,
        isAuthenticated: false,
      }

    // Set the requesting flag and append a message to be shown
    case LOGIN_REQUESTING:
      return {
        ...state,
        requesting: true,
        successful: false,
        messages: [{ body: 'Logging in...', time: new Date() }],
        errors: [],
        email: action.payload.email,
        logo: action.payload.logo,
      }
    // Successful?  Reset the login state.
    case LOGIN_SUCCESS:
      return {
        ...state,
        errors: [],
        messages: [],
        requesting: false,
        successful: true,
        email: action.payload.email,
        logo: action.payload.logo,
      }

    // Append the error returned from our api
    // set the success and requesting flags to false
    case LOGIN_ERROR:
      return {
        ...state,
        // errors: state.errors.concat([
        //   {
        //     body: action.error.toString(),
        //     time: new Date(),
        //   },
        // ]),
        messages: [],
        requesting: false,
        successful: false,
      }

    default:
      return state
  }
}
